import React, { useState } from 'react';
import QuestionAnswer from './question-answer';
import { ChevronDown, ChevronUp, Dice3 } from 'lucide-react';
import { QuestionStats } from 'src/redux/survey/survey.types';
import { Button } from 'src/components/ui/button';
import OverviewDetails from './overview-details';

interface QuestionCardProps {
  index: number;
  question: QuestionStats;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ index, question }) => {
  const [showFeedback, setShowFeedback] = useState(false);

  const handleAnswerClick = (answerId: string) => {
    console.log(answerId);
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4 mb-4 relative">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <div className="flex size-6 shrink-0 rounded-full bg-blue-500 items-center justify-center">
            <div className="text-white">
              {index + 1}
            </div>
          </div>
          <h4 className="text-2xl font-light text-gray-600 ml-4">
            {question.title}
          </h4>

        </div>

        <div className="flex items-center gap-2 mr-4 text-md">
          <div className="">
            {/* <Dice1 className="w-4 h-4 text-gray-500" /> */}
            <Dice3 className="w-4 h-4 text-gray-600" />
          </div>
          <span className="text-gray-600">
            4/4
          </span>

        </div>
      </div>
      <div className="flex flex-col gap-2">
        {question.answers &&
          [...question.answers]
            .sort((a, b) => b.totalPercentage - a.totalPercentage)
            .map((answer) => (
              <QuestionAnswer
                key={answer.id}
                answer={answer}
                handleAnswerClick={handleAnswerClick}
              />
            ))}
      </div>
      <div className="flex items-center justify-between text-gray-600 text-sm mt-2">
        <div>
          <Button
            variant="outline"
            size="sm"
            className="text-gray-600"
            onClick={() => setShowFeedback(!showFeedback)}
          >
            {showFeedback ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
            {/* Feedback */}
          </Button>
        </div>
        <div>
          {question.answers?.length}
          {' '}
          answers
        </div>
      </div>

      <OverviewDetails
        show={showFeedback}
        question={question}
      />

    </div>
  );
};

export default QuestionCard;
